var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgErrorLabel = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 11 11"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 4.5h4.5V0H3.01v3.01H0zM10.96 4.5h-4.5V0h1.49v3.01h3.01zM0 6.4h4.5v4.5H3.01V7.89H0zM10.96 6.4h-4.5v4.5h1.49V7.89h3.01z"
})));
export default SvgErrorLabel;